import mixin from '../mixins/mixin';
import Observable from '../mixins/observable';
import MapMarker from './MapMarker';
import mapStyles from './map-styles';

import $ from 'jquery';

/* global google */

/*

model=instance of Sava.Map.MapModel
elements={container: JQuery object}
settings={'single_marker_zoom_level': <int>, 'location_on_map_zoom_level': <int>, 'clustering': <boolean>}

 */

function MapView(model, elements, settings) {
  this.model = model;
  this.elements = elements;
  this.map = null;
  this.mapHeight = null;
  this.markers = {};
  this.settings = {};
  this.setSettings(settings);
  this.model.addListener(this);
  this.clusterer = null;
  this.displayMarkers(this.model.getMarkerMapData(), true);
  this.init();
}

MapView.prototype = mixin({}, Observable, {
  initial_parameters: {
    lat: 45.2,
    lng: 13.2,
    scrollwheel: false,
    mapTypeControl: false,
    streetViewControl: false,
    zoom: 8,
  },

  default_settings: {
    single_marker_zoom_level: 11,
    location_on_map_zoom_level: 11,
  },

  init() {
    const obj = this;
    google.maps.event.addListener(this.map, 'click', () => {
      obj.model.unselectLocation();
    });
  },

  unInit() {
    $(window).off('resize.google_map_view');
    google.maps.event.clearListeners(this.map, 'click');
    this.map = null;
  },

  isMapVisible() {
    if (this.elements.container.css('display') === 'none') return false;
    return true;
  },

  setMobileHeight() {
    let height = 450; // default minimum height
    if (
      typeof this.elements.nav !== 'undefined' &&
      this.elements.nav.outerHeight() > height
    ) {
      height = this.elements.nav.outerHeight();
    }
    this.mapHeight = height;
    this.elements.container.css({
      height: this.mapHeight,
    });
  },

  setSettings() {
    const settings = JSON.parse(JSON.stringify(this.default_settings));
    if (typeof settings !== 'undefined') {
      for (const setting in settings) {
        this.settings[setting] = settings[setting];
      }
    }
  },

  setStyle() {

    const styledMap = new google.maps.StyledMapType(mapStyles, {
      name: 'Google Map',
    });

    this.map.mapTypes.set('map_style', styledMap);
    this.map.setMapTypeId('map_style');
  },

  /*

    markerlist=[{"lat": <float>, "lng": <float>, "type": <string>, "id": <int>}, ...]

    */

  displayMultipleMarkers(markerList, useInitialView) {
    let latLngMarker;
    const bounds = new google.maps.LatLngBounds();

    const markersList = [];
    for (let i = 0; i < markerList.length; i++) {
      latLngMarker = new google.maps.LatLng(
        markerList[i].lat,
        markerList[i].lng,
      );
      bounds.extend(latLngMarker);
      this.markers[markerList[i].id] = new MapMarker(
        this.model,
        markerList[i].id,
        latLngMarker,
        markerList[i].type,
      );
      markersList.push(this.markers[markerList[i].id].marker);
    }
    let mapCenter;
    if (this.map === null) {
      mapCenter =
        typeof useInitialView !== 'undefined' && useInitialView
          ? new google.maps.LatLng(
            this.initial_parameters.lat,
            this.initial_parameters.lng,
          )
          : bounds.getCenter();
      this.map = new google.maps.Map(this.elements.instance[0], {
        center: mapCenter,
        scrollwheel: this.initial_parameters.scrollwheel,
        mapTypeControl: this.initial_parameters.mapTypeControl,
        streetViewControl: this.initial_parameters.streetViewControl,
      });
      this.setStyle();
    }
    if (typeof useInitialView !== 'undefined' && useInitialView) {
      this.map.setCenter(mapCenter);
      this.map.setZoom(this.initial_parameters.zoom);
    } else {
      this.map.fitBounds(bounds);
    }

    for (const id in this.markers) {
      this.markers[id].addToMap(this.map);
    }
  },

  /*
      markerData = {"lat": <float>, "lng": <float>, "type": <string>, "id": <int>}
    */

  displaySingleMarker(markerData) {
    const latLngMarker = new google.maps.LatLng(markerData.lat, markerData.lng);
    this.markers[markerData.id] = new MapMarker(
      this.model,
      markerData.id,
      latLngMarker,
      markerData.type,
    );
    if (this.map === null) {
      this.map = new google.maps.Map(this.elements.instance[0], {
        center: latLngMarker,
        zoom: this.settings.single_marker_zoom_level,
        scrollwheel: this.initial_parameters.scrollwheel,
        mapTypeControl: this.initial_parameters.mapTypeControl,
        streetViewControl: this.initial_parameters.streetViewControl,
      });
      this.setStyle();
    } else {
      this.map.setZoom(this.settings.single_marker_zoom_level);
      this.map.setCenter(latLngMarker);
      google.maps.event.trigger(this.map, 'resize');
    }
    this.markers[markerData.id].addToMap(this.map);
  },

  nothingToDisplay() {
    if (this.map === null) {
      const latLngMarker = new google.maps.LatLng(
        this.initial_parameters.lat,
        this.initial_parameters.lng,
      );

      this.map = new google.maps.Map(this.elements.instance[0], {
        center: latLngMarker,
        zoom: this.initial_parameters.zoom,
        scrollwheel: this.initial_parameters.scrollwheel,
        mapTypeControl: this.initial_parameters.mapTypeControl,
        streetViewControl: this.initial_parameters.streetViewControl,
      });
      this.setStyle();
    }
  },

  displayMarkers(markerData, useInitialView) {
    this.clearMarkers();

    if (Array.isArray(markerData) === false) {
      return;
    }

    if (markerData.length === 0) {
      this.nothingToDisplay();
    } else if (markerData.length === 1) {
      this.displaySingleMarker(markerData[0]);
    } else {
      this.displayMultipleMarkers(markerData, useInitialView);
    }
  },

  getMarker(id) {
    if (id in this.markers) return this.markers[id];
    return null;
  },

  zoomOutLocation() {
    const bounds = new google.maps.LatLngBounds();
    let numOfMarkers = 0;
    for (const locationId in this.markers) {
      numOfMarkers++;
      bounds.extend(this.markers[locationId].marker.getPosition());
    }
    if (numOfMarkers > 1) {
      this.map.fitBounds(bounds);
    }
  },

  zoomInLocation(locationId, offsetX, offsetY) {
    if (typeof this.markers[locationId] !== 'undefined') {
      this.map.setZoom(this.settings.location_on_map_zoom_level);
      this.map.setCenter(
        this.getCenterOffset(
          this.markers[locationId].marker.getPosition(),
          offsetX,
          offsetY,
        ),
      );
      google.maps.event.trigger(this.map, 'resize');
    }
  },

  getCenterOffset(latLng, offsetX, offsetY) {
    const scale = Math.pow(2, this.map.getZoom());
    const worldCoordinateCenter = this.map
      .getProjection()
      .fromLatLngToPoint(latLng);
    const worldCoordinateOffsetCenter = new google.maps.Point(
      worldCoordinateCenter.x -
        (typeof offsetX === 'undefined' ? 0 : offsetX / scale),
      worldCoordinateCenter.y +
        (typeof offsetY === 'undefined' ? 0 : offsetY / scale),
    );
    return this.map
      .getProjection()
      .fromPointToLatLng(worldCoordinateOffsetCenter);
  },

  fromLatLngToContainerPixel(latLngObject) {
    const bounds = this.map.getBounds();
    const latLngMapWidth =
      bounds.getNorthEast().lng() - bounds.getSouthWest().lng();
    const latLngMapHeight =
      bounds.getSouthWest().lat() - bounds.getNorthEast().lat();
    const latLngWidth = latLngObject.lng() - bounds.getSouthWest().lng();
    const latLngHeight = latLngObject.lat() - bounds.getNorthEast().lat();
    const mapSize = this.getSize();
    return {
      x: Math.round(latLngWidth * mapSize.width / latLngMapWidth),
      y: Math.round(latLngHeight * mapSize.height / latLngMapHeight),
    };
  },

  getSize() {
    return 0;
    // return {
    //   width: $(this.mapContainer).outerWidth(),
    //   height: $(this.mapContainer).outerHeight()
    // };
  },

  clearMarkers() {
    for (const locationId in this.markers) {
      this.markers[locationId].uninit();
      this.markers[locationId].addToMap(null);
    }
    if (this.clusterer !== null) {
      this.clusterer.clearMarkers();
    }
    this.markers = {};
  },

  onLocationBlur(locationId) {
    if (typeof this.markers[locationId] !== 'undefined') {
      if (this.model.getSelectedLocation() !== locationId) {
        this.markers[locationId].displayInactiveState();
      }
    }
  },

  onLocationFocus(locationId) {
    if (typeof this.markers[locationId] !== 'undefined') {
      this.markers[locationId].displayActiveState();
    }
  },

  onMarkerDataLoadEnd(eventObj) {
    this.displayMarkers(eventObj);
    this.notifyListeners('onMarkerDataPopulated');
  },

  onSelect(eventObj) {
    this.zoomInLocation(eventObj.new, 0, -50);
    if (typeof this.markers[eventObj.new] !== 'undefined') {
      this.markers[eventObj.new].displayActiveState();
    }
    if (typeof this.markers[eventObj.old] !== 'undefined') {
      this.markers[eventObj.old].displayInactiveState();
    }
  },

  onUnselect(locationId) {
    //this.zoomOutLocation();
    if (typeof this.markers[locationId] !== 'undefined') {
      this.markers[locationId].displayInactiveState();
    }
  },
});

export default MapView;



// WEBPACK FOOTER //
// ./src/js/maps/MapView.js